var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.conf.componentName,{tag:"component",attrs:{"c-conf":_vm.conf}})}
var staticRenderFns = []

export { render, staticRenderFns }